import { render, staticRenderFns } from "./SelectorLenguaje.vue?vue&type=template&id=ac2b7808&"
import script from "./SelectorLenguaje.vue?vue&type=script&lang=js&"
export * from "./SelectorLenguaje.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports